export default __webpack_public_path__ + "static/farming-en-db9a4773ab700bb8d3a19daa900db311.jpg";